import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { MonitoringService } from './monitoring.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private injector: Injector) { }

  handleError(error: any): void {
    const monitoringService = this.injector.get(MonitoringService);
    monitoringService.trackException(error);
    console.error(error); // Log to console as well
  }
}
